import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { Text, TextType } from 'ui-components/components/text';
import { USD } from '../../../../../constants/currency-codes';
import { DimensionUnit } from '../../../../../enums/dimension-unit';
import { WeightUnit } from '../../../../../enums/weight-unit';
import { useDimensionUnitOfMeasure, useWeightUnitOfMeasure } from '../../../../../hooks/use-seller-setting';
import { CurrencyService } from '../../../../../services/currency-service';
import Global from '../../../../../store/global-selectors';

export const weightUnitsAbbreviations = {
  [WeightUnit.Gram]: 'g',
  [WeightUnit.Grams]: 'g',
  [WeightUnit.Kilogram]: 'kg',
  [WeightUnit.Kilograms]: 'kg',
  [WeightUnit.Ounce]: 'oz',
  [WeightUnit.Ounces]: 'oz',
  [WeightUnit.Pound]: 'lbs',
  [WeightUnit.Pounds]: 'lbs',
};

export const dimensionUnitsAbbreviations = {
  [DimensionUnit.Centimeter]: 'cm',
  [DimensionUnit.Centimeters]: 'cm',
  [DimensionUnit.Inch]: 'in',
  [DimensionUnit.Inches]: 'in',
};

export const WeightUnitLabel = ({ className }) => {
  const weightUnit = useWeightUnitOfMeasure();
  const abbreviation = weightUnitsAbbreviations[weightUnit] ?? weightUnit;
  return <UnitLabel className={className} unit={abbreviation} />;
};

export const DimensionUnitLabel = ({ className }) => {
  const dimensionUnit = useDimensionUnitOfMeasure();
  const abbreviation = dimensionUnitsAbbreviations[dimensionUnit] ?? dimensionUnit;
  return <UnitLabel className={className} unit={abbreviation} />;
};

export const CurrencyLabel = ({ className }) => {
  const intl = useIntl();
  const sellerCurrency = useSelector(Global.selectSellerDefaultCurrency) || USD;
  const currencySymbol = CurrencyService.getSymbolFromCode(sellerCurrency, USD, intl.locale);
  return <UnitLabel className={className} unit={currencySymbol.symbol} />;
};

const UnitLabel = ({ unit, className }) => {
  return <Text className={className} textType={TextType.Description} value={`(${unit})`} />;
};
